<mat-toolbar class="footer-container" [ngClass]="{ mobile: (isMobile$ | async) === true, tablet: (isTablet$ | async) === true, mobileAccessToken: (isMobile$ | async) === true && accessToken }">
  <div class="footer-left mat-body-2" [ngClass]="{ 'mat-caption': (isMobile$ | async) === true }">
    <p *ngIf="!accessToken">
      {{ 'WM_TECH.FOOTER.WEMINE_ADDRESS' | translate }}
    </p>
    <p>© {{ currentYear }} {{ 'WM_TECH.FOOTER.WEMINE' | translate }}</p>
  </div>

  <div class="footer-right mat-body-1" *ngIf="!accessToken">
    <ng-container *ngIf="useExternalLinks; else routerLinks">
      <a class="menu-item" [href]="env.techDomain + '/prices'">{{ 'WM_TECH.FOOTER.MMS_PRICES' | translate }}</a>
      <a class="menu-item" [href]="env.techDomain + '/fees'">{{ 'WM_TECH.FOOTER.POOL_FEES' | translate }}</a>
      <a class="menu-item" [href]="env.techDomain + '/support'">{{ 'WM_TECH.FOOTER.SUPPORT' | translate }}</a>
      <a class="menu-item" [href]="env.techDomain + '/terms'">{{ 'WM_TECH.FOOTER.TERMS' | translate }}</a>
      <a class="menu-item" [href]="env.techDomain + '/privacy'">{{ 'WM_TECH.FOOTER.PRIVACY' | translate }}</a>
      <a class="menu-item" [href]="env.techDomain + '/faq'">{{ 'WM_TECH.FOOTER.FAQ' | translate }}</a>
    </ng-container>

    <wm-libs-language-select class="menu-item"></wm-libs-language-select>
  </div>
</mat-toolbar>

<ng-template #routerLinks>
  <a class="menu-item" routerLink="/prices" routerLinkActive="active">{{ 'WM_TECH.FOOTER.MMS_PRICES' | translate }}</a>
  <a class="menu-item" routerLink="/fees" routerLinkActive="active">{{ 'WM_TECH.FOOTER.POOL_FEES' | translate }}</a>
  <a class="menu-item" routerLink="/support" routerLinkActive="active">{{ 'WM_TECH.FOOTER.SUPPORT' | translate }}</a>
  <a class="menu-item" routerLink="/terms" routerLinkActive="active">{{ 'WM_TECH.FOOTER.TERMS' | translate }}</a>
  <a class="menu-item" routerLink="/privacy" routerLinkActive="active">{{ 'WM_TECH.FOOTER.PRIVACY' | translate }}</a>
  <a class="menu-item" routerLink="/faq" routerLinkActive="active">{{ 'WM_TECH.FOOTER.FAQ' | translate }}</a>
</ng-template>
